<template>
  <div>
    <ckeditor
      :modelValue="modelValue"
      :config="mergedConfig"
      @update:modelValue="$emit('update:modelValue', $event)"></ckeditor>
  </div>
</template>

<script>
import CKEditorPlugin from '@enginio/ckeditor4-vue3';

export default {
  name: 'CKEditorWrapper',
  components: {
    ckeditor: CKEditorPlugin.component,
  },
  emits: ['update:modelValue'],
  props: {
    modelValue: {
      type: String,
      required: false,
      default: '',
    },
    config: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  computed: {
    // The "standard-all" CDN build (the default editorUrl in ckeditor4-vue3) ships a
    // config.js with "align"/"colors" toolbar groups already defined, but doesn't bundle
    // the justify/font/colorbutton plugins that actually populate those groups with
    // buttons — hence alignment and font/background color silently not appearing. Those
    // plugins' files are still hosted on the CDN and loadable on demand, so pull them in
    // here rather than requiring every call site to remember to.
    mergedConfig() {
      const requiredPlugins = ['justify', 'font', 'colorbutton'];
      const existingPlugins = (this.config.extraPlugins || '')
        .split(',')
        .map(plugin => plugin.trim())
        .filter(Boolean);
      const extraPlugins = [...new Set([...existingPlugins, ...requiredPlugins])].join(',');
      return { ...this.config, extraPlugins };
    },
  },
};
</script>
